import { graphql } from '@eluve/graphql.tada';

export const conversationStarterDefaultFragment = graphql(`
  fragment ConversationStarterDefault on ConversationStarterDefaults @_unmask {
    __typename
    id
    tenantId
    userId
    specialty
    language
    starters
    createdAt
    updatedAt
    tenant {
      __typename
      id
      name
    }
    user {
      __typename
      id
      email
      firstName
      lastName
    }
  }
`);

// Query global defaults (no tenant, no user)
export const getGlobalConversationStarterDefaultsQuery = graphql(
  `
    query getGlobalConversationStarterDefaults {
      conversationStarterDefaults(
        where: { tenantId: { _isNull: true }, userId: { _isNull: true } }
        orderBy: { createdAt: ASC }
      ) {
        ...ConversationStarterDefault
      }
    }
  `,
  [conversationStarterDefaultFragment],
);

// Query tenant-level defaults
export const getTenantConversationStarterDefaultsQuery = graphql(
  `
    query getTenantConversationStarterDefaults($tenantId: uuid!) {
      tenantDefaults: conversationStarterDefaults(
        where: { tenantId: { _eq: $tenantId }, userId: { _isNull: true } }
        orderBy: { createdAt: ASC }
      ) {
        ...ConversationStarterDefault
      }
    }
  `,
  [conversationStarterDefaultFragment],
);

// Insert a new conversation starter default
export const insertConversationStarterDefaultMutation = graphql(
  `
    mutation insertConversationStarterDefault(
      $tenantId: uuid
      $userId: uuid
      $specialty: citext
      $language: String
      $starters: jsonb!
    ) {
      insertConversationStarterDefaultsOne(
        object: {
          tenantId: $tenantId
          userId: $userId
          specialty: $specialty
          language: $language
          starters: $starters
        }
      ) {
        ...ConversationStarterDefault
      }
    }
  `,
  [conversationStarterDefaultFragment],
);

// Update an existing conversation starter default
export const updateConversationStarterDefaultMutation = graphql(
  `
    mutation updateConversationStarterDefault(
      $id: uuid!
      $starters: jsonb!
      $specialty: citext
      $language: String
    ) {
      updateConversationStarterDefaultsByPk(
        pkColumns: { id: $id }
        _set: {
          starters: $starters
          specialty: $specialty
          language: $language
        }
      ) {
        ...ConversationStarterDefault
      }
    }
  `,
  [conversationStarterDefaultFragment],
);

// Delete a conversation starter default
export const deleteConversationStarterDefaultMutation = graphql(`
  mutation deleteConversationStarterDefault($id: uuid!) {
    deleteConversationStarterDefaultsByPk(id: $id) {
      __typename
      id
    }
  }
`);
